import React from "react";
import styles from "./LocalParticipantLayout.module.css";
import { useSelector } from "react-redux";
import { Room } from "twilio-video";
import { RootState } from "store/reducers";
import { RemoteParticipant } from "../remote-participant/RemoteParticipant";
import { LocalParticipant } from "../local-participant/LocalParticipant";
import { useParticipantsInAreaFilter } from "hooks/useParticipantsInAreaFilter";
import { useInteractivityListeners } from "hooks/useInteractivityListeners";

interface LocalParticipantLayoutProps {
  room: Room;
  participantsInArea: string[];
}

/** This layout component is rendered for a participant when they are screen sharing. */
export const LocalParticipantLayout: React.FC<LocalParticipantLayoutProps> = ({
  room,
  participantsInArea,
}) => {
  const { participants } = useSelector((s: RootState) => s.remoteParticipants);
  const { participantsInAreaFilter } = useParticipantsInAreaFilter(
    participantsInArea
  );
  useInteractivityListeners(styles["local-participant-container"]);

  return (
    <>
      <div className={styles["local-participant-container"]}>
        <LocalParticipant
          key={room.localParticipant.sid + "-local-participant"}
          participant={room.localParticipant}
          inSidebar={false}
        />
        <div
          className={styles["hide"]}
        >
          {participants.filter(participantsInAreaFilter).map((p) => {
            const participant = room.participants.get(p.sid);
            if (participant) {
              return (
                <RemoteParticipant
                  key={participant.sid + "-remote-tracks"}
                  participant={participant}
                  participantState={p}
                  audioOnly={true}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    </>
  );
};
